import axios from "axios";

interface IGetProvincesParams {
    country: string
}

export const getProvinces = async (params: IGetProvincesParams): Promise<string[]> => {
    const response = await axios.get('/booking/instool/provinces', {
        params
    });
    return response.data;
};

export default getProvinces;